module.exports = __webpack_public_path__ + "static/media/gencat-nuevo-completo-w.f64cb67a.svg";